import { AnimationControls } from 'framer-motion';

import {
  CreateHubspotEngagementMutationResult,
  EmailMessageDto,
  QuickActionDto
} from '@/api/generated';

export type QuickActionFunctionType =
  | CreateHubspotEngagementMutationResult
  | EmailMessageDto
  | undefined;

export interface QuickActionProps {
  quickAction: QuickActionDto;
  index: number;
  firstQuickActionControls: AnimationControls;
  secondQuickActionControls: AnimationControls;
}

export interface QuickActionLogicProps {
  quickAction: QuickActionDto;
  index: number;
}

export enum HubspotProviderOptions {
  Contacts = 'Contacts',
  Company = 'Companies'
}

export type HubspotCompany = {
  id: string;
  name: string;
};
